// contributors-d
//
// Purpose: Community contributor preset categories (D)
//
// This module:
// - Exports preset categories: Formskooooo through DX7FM Novelty

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const contributorCategoriesD: InputPresetCategory[] = [
	{
		name: "Formskooooo's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Bass Clarinet",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "bellows", "reed"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 1664.21, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "reverb", "ring mod"],
					pitchShiftSemitones: 0,
					ringMod: 0,
					ringModHz: 52,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 0,
					reverb: 42,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					harmonics: [
						100, 43, 86, 57, 86, 71, 86, 71, 71, 71, 71, 71, 71, 100, 100, 57, 43, 43,
						43, 57, 57, 57, 43, 43, 43, 29, 14, 0,
					],
					unison: "vary",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Dubstep Gee",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "dubstep", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2 }],
					eqSubFilters1: [{ type: "low-pass", cutoffHz: 594.6, linearGain: 1 }],
					effects: ["note filter", "bitcrusher", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						43, 57, 71, 86, 86, 71, 57, 57, 43, 29, 29, 43, 43, 57, 71, 86, 86, 100, 86,
						100, 71, 43, 43, 29, 29, 29, 29, 29,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Glass Click",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "retro", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2.8284 },
					],
					effects: ["vibrato", "echo"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 0, 29, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 71, 86, 0, 86, 0, 0, 0, 0, 100, 86,
						14, 57, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chordhating Lead",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "pad"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 1664.21, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"distortion",
						"chorus",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 }],
					distortion: 57,
					aliases: false,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					harmonics: [
						100, 43, 86, 57, 86, 71, 86, 71, 71, 71, 71, 71, 71, 43, 71, 71, 57, 57, 57,
						57, 57, 57, 43, 43, 43, 29, 14, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Shruti Box",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "picked", "retro"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						43, 43, 43, 43, 43, 57, 57, 43, 43, 57, 71, 86, 71, 71, 86, 86, 100, 86, 57,
						71, 57, 43, 57, 43, 43, 57, 57, 43,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.6667,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "Ladder Banjo",
				generalMidi: false,
				tags: ["harmonics", "formskooooo", "retro", "picked", "guitar"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 71, 71, 71, 71, 71, 71, 43, 43, 43, 43, 43,
						14, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Nyckelharpa",
				generalMidi: false,
				tags: ["fm", "fm4op", "formskooooo", "picked", "string"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["transition type", "chord type", "vibrato", "chorus"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "Tubaphone",
				generalMidi: false,
				tags: ["fm", "fm4op", "formskooooo", "bellows", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "vibrato", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					panDelay: 10,
					chorus: 43,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "cat wao",
				generalMidi: false,
				tags: ["chip", "chipwave", "formskooooo"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: ["transition type", "note filter", "bitcrusher"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 11.3137 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "formskooooo"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "formskooooo"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "formskooooo"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "formskooooo"], settings: {} },
		]),
	},
	{
		name: "dragoncoder047's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "distorted saw 3",
				generalMidi: false,
				tags: ["fm", "fm4op", "dragoncoder047"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 2,
						},
					],
					panDelay: 0,
					chorus: 100,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "robot 1",
				generalMidi: false,
				tags: ["chip", "customchip", "dragoncoder047"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["detune", "note filter", "chorus", "reverb"],
					detuneCents: 200,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 }],
					panDelay: 0,
					chorus: 100,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			{
				name: "robot 2",
				generalMidi: false,
				tags: ["chip", "customchip", "dragoncoder047"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["detune", "note filter", "chorus", "reverb"],
					detuneCents: 200,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 8 }],
					panDelay: 0,
					chorus: 100,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": -24,
						"31": -24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -24,
						"37": -24,
						"38": -24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": -24,
						"48": -24,
						"49": -24,
						"50": -24,
						"51": -24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			{
				name: "cracked bass",
				generalMidi: false,
				tags: ["chip", "customchip", "dragoncoder047"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 }],
					effects: ["chorus", "reverb"],
					panDelay: 0,
					chorus: 57,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": -4,
						"2": -9,
						"3": -12,
						"4": -14,
						"5": -16,
						"6": -19,
						"7": -20,
						"8": -21,
						"9": -22,
						"10": -23,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 21,
						"17": 21,
						"18": 21,
						"19": 21,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -23,
						"25": -22,
						"26": -21,
						"27": -20,
						"28": -19,
						"29": -16,
						"30": -14,
						"31": -12,
						"32": -9,
						"33": -4,
						"34": 0,
						"35": 5,
						"36": 10,
						"37": 12,
						"38": 15,
						"39": 17,
						"40": 20,
						"41": 21,
						"42": 22,
						"43": 23,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": -22,
						"49": -22,
						"50": -22,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 23,
						"56": 22,
						"57": 21,
						"58": 20,
						"59": 17,
						"60": 15,
						"61": 12,
						"62": 10,
						"63": 5,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "aurora organ",
				generalMidi: false,
				tags: ["fm", "fm4op", "dragoncoder047", "featured"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					effects: ["granular", "chorus", "reverb"],
					granular: 3,
					grainSize: 37,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 71,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "cave dream",
				generalMidi: false,
				tags: ["chip", "chipwave", "dragoncoder047"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1 }],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 43,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 42,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					wave: "1/8 pulse",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "chop saw",
				generalMidi: false,
				tags: ["supersaw", "dragoncoder047", "featured"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 32,
					decimalOffset: 0,
					dynamism: 50,
					spread: 42,
					shape: 33,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "distant alarm",
				generalMidi: false,
				tags: ["chip", "chipwave", "dragoncoder047"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.7071 }],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.025,
					unisonOffset: 0,
					unisonExpression: 0.9,
					unisonSign: -0.8,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "motor noise",
				generalMidi: false,
				tags: ["chip", "customchip", "dragoncoder047"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 2,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": -4,
						"2": -9,
						"3": -12,
						"4": -14,
						"5": -16,
						"6": -19,
						"7": -20,
						"8": -21,
						"9": -14,
						"10": 0,
						"11": -7,
						"12": -6,
						"13": -4,
						"14": -1,
						"15": 1,
						"16": 6,
						"17": 3,
						"18": 1,
						"19": 1,
						"20": -4,
						"21": -6,
						"22": -9,
						"23": -10,
						"24": -12,
						"25": -14,
						"26": -16,
						"27": -21,
						"28": -19,
						"29": -16,
						"30": -14,
						"31": -8,
						"32": -6,
						"33": -3,
						"34": -1,
						"35": 1,
						"36": 3,
						"37": 6,
						"38": 9,
						"39": 10,
						"40": 13,
						"41": 14,
						"42": 16,
						"43": 18,
						"44": 19,
						"45": 21,
						"46": 23,
						"47": 24,
						"48": 13,
						"49": 11,
						"50": 8,
						"51": 6,
						"52": 3,
						"53": 1,
						"54": 16,
						"55": 16,
						"56": 16,
						"57": 16,
						"58": 16,
						"59": 16,
						"60": 17,
						"61": 17,
						"62": 10,
						"63": 5,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "ruler pluck",
				generalMidi: false,
				tags: ["fm", "fm4op", "dragoncoder047"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "conduit",
				generalMidi: false,
				tags: ["pickedstring", "dragoncoder047"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["vibrato"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 71, 100, 71, 100, 0, 100, 0, 71, 86, 43, 0, 0, 57, 43, 14, 14, 14,
						57, 43, 14, 14, 29, 43, 43, 14, 14,
					],
					unison: "hum",
					stringSustain: 79,
					envelopes: [
						{
							target: "vibratoDepth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "vibratoDepth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "slapophone",
				generalMidi: false,
				tags: ["fm", "fm6op", "dragoncoder047"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 176.78, linearGain: 8 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 176.78, linearGain: 8 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[], [3], [6, 4], [5], [], []], carrierCount: 2 },
					customFeedback: { mods: [[4, 2], [2, 1], [], [], [4], [4]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "dragoncoder047"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "dragoncoder047"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "dragoncoder047"], settings: {} },
		]),
	},
	{
		name: "Other Community Presets",
		presets: toNameMap([
			// -------------JukeBox 0.0.0 newcomers--------------
			{
				name: "enhanced supersaw - Perriot",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "2×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 10, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "unnamed string - Perriot",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "note filter", "distortion", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1.4142 }],
					distortion: 14,
					aliases: false,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						71, 86, 86, 86, 71, 71, 57, 43, 43, 43, 43, 43, 71, 71, 71, 71, 71, 71, 71,
						71, 57, 43, 43, 43, 43, 43, 43, 29,
					],
					unison: "none",
					stringSustain: 50,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "heavenly choir - Perriot",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "chord type", "note filter", "chorus", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 61,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 96,
					harmonics: [
						71, 86, 86, 71, 71, 71, 43, 43, 43, 43, 29, 29, 29, 29, 43, 43, 43, 14, 43,
						43, 43, 29, 29, 14, 14, 14, 14, 14,
					],
					unison: "fifth",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Astral Pad - Mathieu",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "vibrato", "granular", "ring mod"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.48,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 3,
					grainSize: 45,
					grainAmounts: 10,
					grainRange: 40,
					ringMod: 0,
					ringModHz: 78,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "vibratoDepth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "soggy frog - cach1rul0",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "pitch shift", "note filter", "echo", "reverb"],
					pitchShiftSemitones: 13,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 }],
					pan: 0,
					panDelay: 10,
					echoSustain: 14,
					echoDelayBeats: 0.833,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 100, 100, 86, 86, 71, 57, 57, 43, 43, 29, 29, 14, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 14, 29, 29, 14, 14, 14,
					],
					unison: "none",
					envelopes: [
						{ target: "pitchShift", envelope: "flare 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "swell 1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "doomsday bass - cach1rul0",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 2,
					noteFilter: [],
					echoSustain: 0,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "feedbackAmplitude", envelope: "twang 2" },
					],
					isDrum: false,
				},
			},
			{
				name: "sawtooth chirp - cach1rul0",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 0,
					vibratoSpeed: 28,
					vibratoType: 1,
					pan: 0,
					panDelay: 10,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "sonic-ish lead - cach1ru10",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					effects: [
						"panning",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					detuneCents: 0,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 0,
					aliases: true,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 10,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 0.667,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "sonic bass - cach1ru10",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 1,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 10,
					chorus: 14,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 2", index: 2 },
						{
							target: "feedbackAmplitude",
							envelope: "twang 1",
						},
						{ target: "none", envelope: "twang 3" },
					],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.0.2 newcomers--------------
			{
				name: "bug beat - Cira",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 50,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "pitch shift"],
					pitchShiftSemitones: 14,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(234)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "noteVolume",
							envelope: "linear 1",
						},
					],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.1.0 newcomers--------------
			{
				name: "Frog Bass - Hi",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2 }],
					effects: ["panning", "chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 8,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 8,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					pan: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "supersawShape",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Space EP - Hi",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["panning", "chord type", "detune", "vibrato", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 0,
					vibratoSpeed: 4,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					chorus: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 1,
							waveform: 0,
							steps: 2,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "FM Deep Bass - Silliam",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 0.7071 },
					],
					effects: [
						"panning",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					pan: 0,
					panDelay: 0,
					chorus: 43,
					reverb: 61,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.75×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 12,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "~2×", amplitude: 6, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Ondes Marteno t - s0apic",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 3,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					effects: [
						"panning",
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 20,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 27,
					vibratoSpeed: 12,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					pan: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 81,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -6,
					harmonics: [
						100, 14, 29, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "tremolo5" }],
					isDrum: false,
				},
			},
			{
				name: "Saw n' Bells - s0apic",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.25 },
					],
					effects: [
						"panning",
						"transition type",
						"detune",
						"vibrato",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: -8,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 8,
					vibratoSpeed: 6,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 (2 3)←5←6 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "none", index: 4 },
						{
							target: "operatorAmplitude",
							envelope: "none",
							index: 0,
						},
						{ target: "operatorAmplitude", envelope: "punch", index: 2 },
					],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.1.2 newcomers--------------
			{
				name: "morsed code - rit",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 5.6569,
						},
					],
					effects: ["panning", "reverb"],
					pan: 0,
					panDelay: 0,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.12×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 12, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "miku guitar - rit",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					effects: ["transition type", "chord type", "note filter", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 5.6569 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					harmonics: [
						86, 86, 71, 71, 71, 86, 86, 71, 57, 57, 57, 57, 43, 57, 86, 86, 100, 100,
						100, 86, 71, 57, 57, 100, 100, 100, 100, 100,
					],
					unison: "hold",
					stringSustain: 100,
					envelopes: [
						{
							target: "stringSustain",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "fakebit synth - rit",
				generalMidi: false,
				tags: ["chip", "customchip", "featured"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 57,
					echoSustain: 29,
					echoDelayBeats: 1.5,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -13,
						"1": 5,
						"2": 5,
						"3": 6,
						"4": 9,
						"5": 10,
						"6": 15,
						"7": 18,
						"8": 9,
						"9": 10,
						"10": 10,
						"11": 11,
						"12": 12,
						"13": 12,
						"14": 13,
						"15": 13,
						"16": 10,
						"17": 10,
						"18": 10,
						"19": 10,
						"20": 10,
						"21": 11,
						"22": 11,
						"23": 11,
						"24": 12,
						"25": 12,
						"26": 13,
						"27": 13,
						"28": 14,
						"29": 14,
						"30": 14,
						"31": 15,
						"32": 15,
						"33": 16,
						"34": 16,
						"35": 16,
						"36": 16,
						"37": 16,
						"38": 16,
						"39": 16,
						"40": 16,
						"41": 15,
						"42": -13,
						"43": -14,
						"44": -14,
						"45": -14,
						"46": -15,
						"47": -15,
						"48": -16,
						"49": -16,
						"50": -16,
						"51": -16,
						"52": -16,
						"53": -15,
						"54": -14,
						"55": -12,
						"56": -10,
						"57": -9,
						"58": -7,
						"59": -6,
						"60": -4,
						"61": -2,
						"62": 0,
						"63": 2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			// -------------JukeBox 0.1.5 newcomers--------------
			{
				name: "Gabber Kick - Randomgoof",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion"],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Guitar-like instrument - Randomgoof",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Yupek FM - Yupekosi",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
					],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "4→5",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 0, waveform: "pulse width", pulseWidth: 4 },
						{
							frequency: "0.75×",
							amplitude: 2,
							waveform: "pulse width",
							pulseWidth: 3,
						},
						{ frequency: "3×", amplitude: 9, waveform: "pulse width", pulseWidth: 9 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "wibble 2" },
						{
							target: "operatorAmplitude",
							envelope: "rise 1",
							index: 4,
						},
						{ target: "feedbackAmplitude", envelope: "decay 1" },
					],
				},
			},
			{
				name: "Frog Chip - Yupekosi",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2,
						},
					],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "modbox 10% pulse",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": 24,
						"2": 24,
						"3": 24,
						"4": 24,
						"5": 24,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 3" }],
				},
			},
			{
				name: "walrus wah - Yupekosi",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 }],
					effects: ["chord type", "vibrato", "note filter", "distortion", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					reverb: 48,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					unison: "none",
					wave: "square",
					customChipWave: {
						"0": -9,
						"1": -12,
						"2": -10,
						"3": -7,
						"4": -5,
						"5": -3,
						"6": -2,
						"7": -1,
						"8": 0,
						"9": 0,
						"10": -1,
						"11": -2,
						"12": -3,
						"13": -5,
						"14": -7,
						"15": -9,
						"16": -11,
						"17": -11,
						"18": -8,
						"19": -7,
						"20": -5,
						"21": -4,
						"22": -3,
						"23": -3,
						"24": -3,
						"25": -3,
						"26": -4,
						"27": -6,
						"28": -8,
						"29": -10,
						"30": -11,
						"31": -9,
						"32": -6,
						"33": -4,
						"34": -1,
						"35": 1,
						"36": 3,
						"37": 4,
						"38": 5,
						"39": 5,
						"40": 5,
						"41": 4,
						"42": 3,
						"43": 2,
						"44": 0,
						"45": -2,
						"46": -4,
						"47": -7,
						"48": -9,
						"49": -11,
						"50": -11,
						"51": -10,
						"52": -8,
						"53": -8,
						"54": -7,
						"55": -8,
						"56": -8,
						"57": -10,
						"58": -11,
						"59": -11,
						"60": -9,
						"61": -6,
						"62": -4,
						"63": -1,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Sawtooth Wah - Yupekosi",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: ["transition type", "note filter", "bitcrusher"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 5.6569 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 48,
					unison: "none",
					wave: "sawtooth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterFreq", envelope: "flare 2", index: 0 }],
				},
			},
			{
				name: "saturnic chip - Yupekosi",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
					],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					unison: "none",
					wave: "soft clarinet",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "pulse aah - Yupekosi",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					eqSubFilters1: [],
					effects: ["transition type", "vibrato"],
					transition: "slide",
					clicklessTransition: false,
					slideTicks: 3,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					unison: "none",
					pulseWidth: 10,
					decimalOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "supersonic chip - Yupekosi",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 2.8284,
						},
					],
					effects: ["chord type", "echo", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 0.417,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3)←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 8, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "supersaw goof pad - Yupekosi",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "note filter", "distortion"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 57,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 44,
					decimalOffset: 0,
					dynamism: 100,
					spread: 67,
					shape: 67,
					envelopes: [
						{ target: "noteVolume", envelope: "decay 2" },
						{
							target: "pulseWidth",
							envelope: "decay 1",
						},
					],
				},
			},
			{
				name: "Ghoul Dance - 'Unregistered account'",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 250, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 250, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.5,
						},
					],
					effects: ["echo", "reverb"],
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.083,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "1 2 3←5 4←6",
					feedbackType: "3→4",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "0.12×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 7,
						},
						{
							frequency: "0.25×",
							amplitude: 15,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{ frequency: "0.12×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
						},
					],
				},
			},
			{
				name: "16bit crushed bass - trexsiyo",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[2, 6], [3], [4, 6], [5], [], []], carrierCount: 2 },
					customFeedback: { mods: [[1], [], [1], [], [], [1]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "vibey crushed - trexsiyo",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
					],
					effects: [
						"chord type",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 0.667,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 23,
						"3": 22,
						"4": 21,
						"5": 21,
						"6": 20,
						"7": 19,
						"8": 18,
						"9": 18,
						"10": 17,
						"11": 16,
						"12": 15,
						"13": 15,
						"14": 14,
						"15": 13,
						"16": 12,
						"17": 12,
						"18": 11,
						"19": 10,
						"20": 9,
						"21": 9,
						"22": 8,
						"23": 7,
						"24": 6,
						"25": 6,
						"26": 5,
						"27": 4,
						"28": 3,
						"29": 3,
						"30": 2,
						"31": 1,
						"32": 0,
						"33": 0,
						"34": -1,
						"35": -2,
						"36": -3,
						"37": -3,
						"38": -4,
						"39": -5,
						"40": -6,
						"41": -6,
						"42": -7,
						"43": -8,
						"44": -9,
						"45": -9,
						"46": -10,
						"47": -11,
						"48": -12,
						"49": -12,
						"50": -13,
						"51": -14,
						"52": -15,
						"53": -15,
						"54": -16,
						"55": -17,
						"56": -18,
						"57": -18,
						"58": -19,
						"59": -20,
						"60": -21,
						"61": -21,
						"62": -22,
						"63": -23,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			// -------------JukeBox 0.1.6 newcomers--------------
			{
				name: "DeathBass - p1th0n",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "distortion"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 5, waveform: "pulse width", pulseWidth: 10 },
						{ frequency: "0.5×", amplitude: 14, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.0 presets--------------
			{
				name: "Kacho's Scream - Crying Baby",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion", "reverb"],
					distortion: 57,
					aliases: false,
					panDelay: 10,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 86, 71, 43, 43, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
						57, 57, 57, 71, 71, 71, 71, 57, 57, 43,
					],
					unison: "inject",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Sucker's Violin - Luxian",
				generalMidi: false,
				tags: ["fm", "fm6op", "featured", "string"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["vibrato", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 68,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 2,
					customAlgorithm: {
						mods: [[4, 6, 2, 3, 5], [3, 5, 4], [4, 6, 5], [6], [6], []],
						carrierCount: 2,
					},
					customFeedback: { mods: [[1], [2, 1], [3], [4, 5], [5, 4], []] },
					operators: [
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "decay 3" }],
				},
			},
			{
				name: "Boowww Bass - Randomgoof",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Very Weird bass - Randomgoof",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus"],
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Broken Bell - Dono915",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 4 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 4 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.5,
						},
					],
					effects: ["pitch shift", "note filter", "bitcrusher", "reverb"],
					pitchShiftSemitones: 20,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
					],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 0, 0, 0, 57, 0, 14, 0, 43, 0, 0, 100, 0, 14, 0, 57, 100, 0, 86, 0, 0, 0,
						29, 71, 71, 43, 0, 0,
					],
					unison: "dissonant",
					stringSustain: 57,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 0 },
						{
							target: "unison",
							envelope: "note size",
						},
					],
				},
			},
			{
				name: "Slapaphone - Dono915",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 }],
					effects: ["chorus", "reverb"],
					panDelay: 0,
					chorus: 57,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 29, 57, 57, 29, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 29, 14, 29, 14, 29,
						0, 0, 0, 0, 0, 0, 29,
					],
					unison: "hum",
					stringSustain: 21,
					envelopes: [
						{ target: "stringSustain", envelope: "twang 1" },
						{
							target: "noteVolume",
							envelope: "punch",
						},
					],
				},
			},
			{
				name: "Arcade Banjo - p1th0n",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 8 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 8 }],
					eqSubFilters1: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1.4142 }],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 16,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 83,
					spread: 25,
					shape: 50,
					envelopes: [
						{ target: "noteVolume", envelope: "twang 1" },
						{
							target: "pulseWidth",
							envelope: "twang 1",
						},
					],
				},
			},
			{
				name: "hex square - rit",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 4,
						},
					],
					effects: [
						"transition type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 14,
					aliases: true,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					unison: "hum",
					wave: "square",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Supercharged Brass - KoraCaesh",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "detune"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					detuneCents: 5,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6.05,
					unisonOffset: 6,
					unisonExpression: 1.4,
					unisonSign: 1,
					unisonBuzzes: false,
					pulseWidth: 14,
					decimalOffset: 0,
					envelopes: [
						{ target: "unison", envelope: "twang -1" },
						{ target: "unison", envelope: "twang 1" },
					],
				},
			},
			{
				name: "Hyper Guitar - KoraCaesh",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					eqSubFilters2: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					effects: ["distortion", "bitcrusher", "chorus", "echo", "reverb"],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "3⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Dubstep Growl - KoraCaesh",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.5 },
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					eqSubFilters2: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					effects: [
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 5.6569 }],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 29,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "2⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "punch", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 3,
						},
						{ target: "operatorFrequency", envelope: "punch", index: 1 },
					],
				},
			},
			{
				name: "Dubstep Laser - KoraCaesh",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.5,
						},
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.5,
						},
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.3536 },
					],
					effects: [
						"pitch shift",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang -1", index: 3 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "operatorFrequency", envelope: "twang -1", index: 0 },
						{ target: "feedbackAmplitude", envelope: "swell 2" },
						{ target: "operatorAmplitude", envelope: "twang -1", index: 1 },
					],
				},
			},
			{
				name: "bossabassa - KoraCaesh",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					eqSubFilters2: [
						{ type: "peak", cutoffHz: 105.11, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
					],
					effects: [
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 0,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "3⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "punch", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "twang 1",
							index: 3,
						},
					],
				},
			},
			{
				name: "soft sawtooth - KoraCaesh",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 57,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 71, 57, 43, 29, 29, 86, 57, 29, 57, 29, 0, 0, 57, 86, 0, 0, 57,
						29, 29, 29, 29, 57, 14, 14, 14, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
				},
			},
			{
				name: "Sewersaw - SunflowerSupreme",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: [
						"transition type",
						"vibrato",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 45,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 67,
					shape: 100,
					envelopes: [],
				},
			},
			{
				name: "Arcadish - SunflowerSupreme",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 57,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2 (3 4 5)←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "0.12×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 11,
							waveform: "pulse width",
							pulseWidth: 7,
						},
						{ frequency: "~1×", amplitude: 10, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "0.75×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "pulse width", pulseWidth: 0 },
					],
					envelopes: [],
				},
			},
			{
				name: "Heavy Bass - SunflowerSupreme",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["pitch shift", "detune", "chorus", "reverb"],
					pitchShiftSemitones: 12,
					detuneCents: 0,
					panDelay: 0,
					chorus: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←(3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Powerhorn - SunflowerSupreme",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 }],
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4",
					feedbackType: "1→2",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "25×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise 2" }],
				},
			},
			{
				name: "Goofy Lyre Lead - Warkentien",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					detuneCents: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "modbox lyre",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 9,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Twang Organ - Warkentien",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 100,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "organ",
					unison: "alternate fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "unison",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Even Brighter - Warkentien",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 100,
					reverb: 58,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					harmonics: [
						100, 86, 86, 86, 43, 43, 43, 71, 100, 43, 100, 100, 43, 43, 57, 71, 57, 43,
						29, 43, 57, 100, 100, 100, 100, 29, 14, 0,
					],
					unison: "weird octave",
					stringSustain: 86,
					envelopes: [],
				},
			},
			{
				name: "Crushed Clarinet - Warkentien",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 }],
					effects: ["transition type", "detune", "vibrato", "bitcrusher", "chorus"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 0,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					wave: "soft clarinet",
					unison: "shimmer",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Slidey Brass - Warkentien",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "chord type", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					panDelay: 0,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "modbox brass",
					unison: "warbled",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 85,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Trumpet or Something - Xelerate_XD",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 2.8284,
						},
					],
					effects: ["note filter", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{ target: "operatorAmplitude", envelope: "swell 1", index: 3 },
						{ target: "feedbackAmplitude", envelope: "flare 2" },
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
					],
				},
			},
			{
				name: "Acoustic Guitar - Xelerate_XD",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "electric guitar",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Better Shamisen - Xelerate_XD",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 840.9, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 840.9, linearGain: 0.7071 }],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.25,
						},
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.25,
						},
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1 },
					],
					panDelay: 0,
					chorus: 43,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "feedbackAmplitude",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Pirate AHH Chip - Xelerate_XD",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "double saw",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Epic Square - Xelerate_XD",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: [
						"pitch shift",
						"detune",
						"vibrato",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 7,
					detuneCents: 112,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					panDelay: 0,
					chorus: 86,
					echoSustain: 86,
					echoDelayBeats: 0.333,
					reverb: 77,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "voiced",
					customChipWave: {
						"0": -24,
						"1": -20,
						"2": -17,
						"3": -15,
						"4": -13,
						"5": -13,
						"6": -11,
						"7": -11,
						"8": -11,
						"9": -9,
						"10": -9,
						"11": -9,
						"12": -9,
						"13": -7,
						"14": -7,
						"15": -7,
						"16": -7,
						"17": -7,
						"18": -5,
						"19": -5,
						"20": -5,
						"21": -5,
						"22": -5,
						"23": -5,
						"24": -3,
						"25": -3,
						"26": -3,
						"27": -3,
						"28": -3,
						"29": -3,
						"30": -3,
						"31": -3,
						"32": 24,
						"33": 20,
						"34": 17,
						"35": 15,
						"36": 13,
						"37": 13,
						"38": 11,
						"39": 11,
						"40": 11,
						"41": 9,
						"42": 9,
						"43": 9,
						"44": 9,
						"45": 7,
						"46": 7,
						"47": 7,
						"48": 7,
						"49": 7,
						"50": 5,
						"51": 5,
						"52": 5,
						"53": 5,
						"54": 5,
						"55": 5,
						"56": 3,
						"57": 3,
						"58": 3,
						"59": 3,
						"60": 3,
						"61": 3,
						"62": 3,
						"63": 3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Epic Double Saw - Xelerate_XD",
				generalMidi: false,
				tags: ["chip", "customchip", "chiptune"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.5,
						},
					],
					effects: ["bitcrusher", "reverb", "phaser"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					phaserMix: 100,
					phaserFreq: 29,
					phaserFeedback: 0,
					phaserStages: 52,
					panDelay: 10,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					unison: "none",
					wave: "square",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 5,
						"5": 5,
						"6": 5,
						"7": 5,
						"8": 10,
						"9": 10,
						"10": 10,
						"11": 10,
						"12": 15,
						"13": 15,
						"14": 15,
						"15": 15,
						"16": 20,
						"17": 20,
						"18": 20,
						"19": 20,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -24,
						"28": 20,
						"29": 20,
						"30": 20,
						"31": 20,
						"32": 15,
						"33": 15,
						"34": 15,
						"35": 15,
						"36": 10,
						"37": 10,
						"38": 10,
						"39": 10,
						"40": 5,
						"41": 5,
						"42": 5,
						"43": 5,
						"44": -24,
						"45": -24,
						"46": -24,
						"47": -24,
						"48": -19,
						"49": -19,
						"50": -19,
						"51": -19,
						"52": -14,
						"53": -14,
						"54": -14,
						"55": -14,
						"56": -9,
						"57": -9,
						"58": -9,
						"59": -9,
						"60": -4,
						"61": -4,
						"62": -4,
						"63": -4,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Cool Bitcrushed Thing - Xelerate_XD",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					effects: ["bitcrusher", "chorus", "reverb"],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 57,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←4)",
					feedbackType: "1→2",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{
							target: "operatorAmplitude",
							envelope: "swell 3",
							index: 3,
						},
						{ target: "feedbackAmplitude", envelope: "punch" },
					],
				},
			},
			{
				name: "Pop Bass - Malicious mandwald",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.1768 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					panDelay: 0,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←2←3←4",
					feedbackType: "(1 2 3)→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "3×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 1" },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
						{ target: "noteVolume", envelope: "linear 1" },
					],
				},
			},
			{
				name: "Evil Electric Guitar - Malicious mandwald",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 707.11,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 707.11,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 1 },
					],
					effects: [
						"transition type",
						"detune",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide in pattern",
					clicklessTransition: false,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 71,
					aliases: false,
					panDelay: 0,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterFreq", envelope: "note size", index: 1 }],
				},
			},
			{
				name: "Large Squid synth - Malicious mandwald",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.125 }],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 5,
					noteFilter: [{ type: "low-pass", cutoffHz: 4116.87, linearGain: 2.8284 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4116.87, linearGain: 2.8284 }],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.417,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 1" },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 3 },
						{ target: "vibratoDepth", envelope: "decay 1" },
						{ target: "noteVolume", envelope: "punch" },
					],
				},
			},
			{
				name: "Untextured Synth - Malicious mandwald",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["detune", "vibrato", "note filter", "chorus", "echo", "reverb"],
					detuneCents: -180,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					panDelay: 0,
					chorus: 14,
					echoSustain: 29,
					echoDelayBeats: 0.583,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "alto sax",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "vibratoDepth",
							envelope: "flute 3",
						},
					],
				},
			},
			// -------------JukeBox 0.2.1 presets--------------
			{
				name: "organ thing worth keeping - dingus",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 100, 100, 100, 0, 100, 0, 100, 0, 0, 0, 100, 0, 0, 0, 100, 0, 0, 0, 0,
						0, 0, 0, 100, 0, 0, 0, 0,
					],
					unison: "honky tonk",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "painful synth - dingus",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
					],
					distortion: 57,
					aliases: false,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "(1 2)←4 3←(5 6)",
					feedbackType: "1⟲",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "budget guitar - rit",
				generalMidi: false,
				tags: ["fm", "fm4op", "featured"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					panDelay: 10,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.2 presets--------------
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Drunk-ish Choir - Stickman",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
					],
					effects: ["detune", "vibrato", "distortion", "chorus", "reverb"],
					detuneCents: 4,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 57,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					reverb: 68,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					harmonics: [
						71, 86, 100, 100, 86, 86, 57, 43, 29, 29, 29, 29, 29, 29, 43, 43, 43, 43,
						43, 29, 29, 29, 29, 14, 14, 14, 14, 14,
					],
					unison: "broke",
					envelopes: [],
				},
			},
			{
				name: "Buzzy Tonk Piano - Stickman",
				generalMidi: false,
				tags: ["noise"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 17,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 4,
						},
					],
					effects: ["chord type", "detune", "vibrato", "bitcrusher"],
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: -20,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "buzz",
					unison: "honky tonk",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Harsh Kick - AlphaSlayer22",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "bitcrusher"],
					pitchShiftSemitones: 0,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Angel Voiced Lead - PiglinMiguel",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide in pattern",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 100,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "80s Video Game Keys - PiglinMiguel",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide in pattern",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Weird Creepy Synth - PiglinMiguel",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"granular",
						"bitcrusher",
						"echo",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 0.25,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "modbox 1% pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 101,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "unsupersaw - dingus",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					effects: ["vibrato", "note filter", "chorus", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0,
					vibratoDelay: 47,
					vibratoSpeed: 3,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 2 }],
					panDelay: 0,
					chorus: 29,
					reverb: 90,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 0,
					shape: 67,
					envelopes: [],
				},
			},
			{
				name: "stupid acid bass - dingus",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 2 }],
					effects: ["vibrato", "note filter"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 8 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "modbox brass",
					unison: "recurve",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 85,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 2" }],
				},
			},
			{
				name: "Hardcore Kick 3 - deathmodereal",
				generalMidi: false,
				tags: ["fm", "fm4op", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{
							frequency: "~20×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "0.25×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 3,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorFrequency", envelope: "twang 1", index: 0 }],
				},
			},
			{
				name: "Hardcore Kick 4 - deathmodereal",
				generalMidi: false,
				tags: ["fm", "fm6op", "kick"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←3 2←4←5←6",
					feedbackType: "1→2",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "50×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "25×", amplitude: 6, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~20×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{
							target: "operatorFrequency",
							envelope: "punch",
							index: 1,
						},
					],
				},
			},
			{
				name: "old piano - rit",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 707.11, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 707.11, linearGain: 4 }],
					effects: [
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					vibrato: "custom",
					vibratoDepth: 0.48,
					vibratoDelay: 11,
					vibratoSpeed: 16,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "brucebox pokey 4bit lfsr",
					unison: "honky tonk",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Small Squid Synth - Malicious Mandwald",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
					],
					effects: ["vibrato", "note filter", "chorus", "echo", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					harmonics: [
						86, 71, 100, 86, 100, 86, 71, 86, 71, 71, 71, 86, 86, 71, 57, 57, 57, 43,
						29, 29, 29, 29, 43, 29, 43, 29, 29, 29,
					],
					unison: "bowed",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Evil Synth - Malicious Mandwald",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "punch" },
						{
							target: "feedbackAmplitude",
							envelope: "flare 1",
						},
					],
				},
			},
			{
				name: "Malicious Organ - Malicious Mandwald",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2,
						},
					],
					eqSubFilters1: [],
					effects: ["distortion", "bitcrusher", "chorus", "echo", "reverb"],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						86, 86, 0, 14, 0, 0, 0, 86, 0, 0, 29, 71, 0, 0, 0, 86, 71, 71, 57, 43, 29,
						0, 29, 14, 14, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{
							target: "unison",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Mirror Forest Synth  - Malicious Mandwald",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 }],
					effects: ["chord type", "vibrato", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					panDelay: 0,
					chorus: 43,
					reverb: 65,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2←3←4",
					feedbackType: "2→4",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 1" },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 1 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 1", index: 3 },
						{ target: "feedbackAmplitude", envelope: "twang 2" },
						{ target: "operatorAmplitude", envelope: "punch", index: 3 },
					],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Bird 1 - Sandbox2",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3) 2←4",
					feedbackType: "3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 9, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Bird 4 - Sandbox2",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.1768 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.75×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "18×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Oboe 2 - Sandbox2",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 1.4142,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					panDelay: 10,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Trumpet 3 - Sandbox2",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqSubFilters1: [],
					effects: ["detune"],
					detuneCents: 29,
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Heavy Guitar - AssholeGuy",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
					],
					effects: [
						"chord type",
						"pitch shift",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 0,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						29, 14, 43, 43, 43, 43, 43, 43, 29, 43, 29, 29, 43, 43, 43, 57, 57, 29, 29,
						29, 29, 29, 29, 29, 14, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 14,
					envelopes: [],
				},
			},
			{
				name: "star bells - rosierabby",
				generalMidi: false,
				tags: ["fm", "fm4op", "featured"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "chorus", "echo"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Factory lead - DJO",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 100,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4 2←(5 6) 3",
					feedbackType: "3→4",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Blackknife lead - DJO",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 100,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←5 (3 4)←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "4×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Choral Square Lead - DJO",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["distortion", "bitcrusher", "chorus", "echo"],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3)←4",
					feedbackType: "1→2",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Square Overdrive - DJO",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["distortion"],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "FM Keylead - DJO",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus", "echo", "reverb"],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 0.833,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "1↔2 3↔4",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hard Core Apogo - DJO",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Baby's square lead - DJO",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["distortion", "chorus", "echo", "reverb"],
					distortion: 71,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 44,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "crushed byow - Hexer",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "peak", cutoffHz: 5656.85, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 5656.85, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 7,
					noteFilter: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 100,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 19,
					decimalOffset: 0,
					dynamism: 83,
					spread: 25,
					shape: 83,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "violince - Hexer",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 5.6569,
						},
					],
					effects: ["detune", "vibrato", "note filter", "reverb"],
					detuneCents: -36,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					panDelay: 10,
					reverb: 68,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					harmonics: [
						100, 86, 43, 29, 43, 71, 71, 57, 0, 57, 29, 43, 57, 14, 43, 43, 43, 0, 29,
						43, 43, 43, 29, 43, 43, 29, 0, 29,
					],
					unison: "dissonant",
					envelopes: [
						{
							target: "detune",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "heartbeat pulse - Hexer",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "hecking gosh",
					customChipWave: {
						"0": 6,
						"1": 6,
						"2": 6,
						"3": 6,
						"4": 5,
						"5": 3,
						"6": 3,
						"7": 3,
						"8": 3,
						"9": 3,
						"10": 3,
						"11": 3,
						"12": 3,
						"13": 3,
						"14": 3,
						"15": 3,
						"16": 2,
						"17": 2,
						"18": 2,
						"19": 2,
						"20": 2,
						"21": 2,
						"22": 1,
						"23": -5,
						"24": -10,
						"25": -12,
						"26": -19,
						"27": -20,
						"28": -14,
						"29": -6,
						"30": 4,
						"31": 10,
						"32": 10,
						"33": 6,
						"34": 1,
						"35": 1,
						"36": 0,
						"37": -1,
						"38": -1,
						"39": -1,
						"40": -1,
						"41": -1,
						"42": -1,
						"43": -1,
						"44": -1,
						"45": -1,
						"46": -1,
						"47": -1,
						"48": -1,
						"49": -1,
						"50": -1,
						"51": -1,
						"52": -1,
						"53": -1,
						"54": -1,
						"55": -1,
						"56": -1,
						"57": -1,
						"58": -1,
						"59": -1,
						"60": -1,
						"61": -1,
						"62": -1,
						"63": -1,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "clumsy bells - Hexer",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "vibrato", "bitcrusher", "chorus", "reverb"],
					detuneCents: -15,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 57,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 0, 43, 71, 57, 43, 100, 0, 57, 71, 43, 43, 43, 57, 71, 71, 86, 57, 57,
						57, 71, 57, 43, 43, 43, 29, 29, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [
						{
							target: "vibratoDepth",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "bee pulse - Hexer",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 7,
					decimalOffset: 0,
					unison: "vary",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Highshelf Keys - NOVA_0943",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 2.8284 },
					],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					echoSustain: 14,
					echoDelayBeats: 0.167,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "sawtooth",
					unison: "piano",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Slidelead - NOVA_0943",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "bitcrusher", "echo", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 71,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "zefbox high pulse",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 13,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Chip Distortion Guitar - NOVA_0943",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "distortion"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "1/8 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Cat Meow - StapyThePinoy",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.1768,
						},
					],
					effects: ["transition type", "vibrato", "note filter", "chorus"],
					transition: "continue",
					clicklessTransition: false,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 3,
					noteFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Square Bass - UnbihexiumFan",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 0.7071,
						},
					],
					effects: ["chord type"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "Kind of accurate synth guitar - th#",
				generalMidi: false,
				tags: ["noise"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "note filter"],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.7071,
						},
					],
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "1-bit metallic",
					unison: "custom",
					unisonVoices: 9,
					unisonSpread: 0.05,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 1,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "harsh distorted lead - cal_grad7",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "Custom",
					feedbackAmplitude: 8,
					customFeedback: { mods: [[], [], [], [1], [5], [5]] },
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "underwater bass - cal_grad7",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					effects: ["transition type", "distortion", "bitcrusher", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 1.417,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "pulsewidth chord  - cal_grad7",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "bitcrusher", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "triple octave",
					envelopes: [
						{
							target: "decimalOffset",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "unstable supersaw - cal_grad7",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1.4142 }],
					effects: ["vibrato", "note filter", "distortion", "chorus", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
					],
					distortion: 100,
					aliases: true,
					panDelay: 0,
					chorus: 57,
					reverb: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 96,
					pulseWidth: 9,
					decimalOffset: 0,
					dynamism: 33,
					spread: 0,
					shape: 33,
					envelopes: [
						{
							target: "supersawSpread",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "vibratoDepth",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: true,
						},
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
				},
			},
			{
				name: "calming ring - why_need_a_username",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 840.9, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 28,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 840.9, linearGain: 11.3137 }],
					effects: ["echo"],
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "echoSustain",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "echoDelay",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "wiggly space thing - mero100",
				generalMidi: false,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 7,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "note filter", "chorus", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 7,
					noteFilter: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					panDelay: 10,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					spectrum: [
						100, 0, 0, 0, 100, 0, 0, 100, 0, 0, 0, 100, 0, 0, 100, 0, 0, 0, 100, 0, 0,
						100, 0, 0, 0, 100, 0, 0, 100, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "chorus",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.06,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Sci-Fi Supersaw - iAmVeryBoring",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.25 },
					],
					effects: ["note filter", "bitcrusher", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.083,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 48,
					decimalOffset: 0,
					dynamism: 50,
					spread: 50,
					shape: 17,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Wibbling Wave - iAmVeryBoring",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 8 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 8 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
					],
					effects: ["pitch shift", "note filter", "echo", "reverb"],
					pitchShiftSemitones: 24,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 7231.23, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7231.23, linearGain: 1 }],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←4(2←5(3←6",
					feedbackType: "(1,2,3,4,5)→6",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.75×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 4, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Heavenly Chords - iAmVeryBoring",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["granular", "chorus", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 10,
					chorus: 14,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 86, 86, 57, 57, 57, 43, 57, 43, 29, 29, 14, 14, 14, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "detune",
					envelopes: [],
				},
			},
			{
				name: "Bitcrushed Lead - iAmVeryBoring",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["granular", "bitcrusher", "chorus", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 71,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 86, 86, 57, 57, 57, 43, 57, 43, 29, 29, 14, 14, 14, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "detune",
					envelopes: [],
				},
			},
			{
				name: "Sliding Chords - iAmVeryBoring",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.7071 },
					],
					effects: ["transition type", "note filter"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 43,
					decimalOffset: 0,
					unison: "honky tonk",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Nintendo Trumpet - yeeyer",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6138.63, linearGain: 2.8284 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 14711.41, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 14711.41, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "chorus feedback pad - LeanManMcGee",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 0,
					reverb: 39,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "crown lead synth - stupid idea",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 }],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 22,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 100,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "1/4 pulse",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 6,
					unisonOffset: -6,
					unisonExpression: 1.4,
					unisonSign: 1,
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Tetromino Chi - BraidenNO31315",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "vibrato", "note filter", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 11,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 86, 71, 57, 57, 43, 43, 29, 29, 29, 43, 43, 43, 57, 57, 57, 57, 71, 71,
						71, 71, 57, 57, 57, 43, 43, 43, 29,
					],
					unison: "honky tonk",
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Tetromino Kera - BraidenNO31315",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{
							target: "noteVolume",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Tetromino Teridar - BraidenNO31315",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 86, 86, 86, 71,
						71, 57, 57, 43, 43, 43, 29, 29, 29, 14, 14, 14,
					],
					unison: "octave",
					stringSustain: 43,
					envelopes: [{ target: "noteVolume", envelope: "punch" }],
				},
			},
			{
				name: "Tetromino Terie - BraidenNO31315",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "5×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "punch", index: 0 }],
				},
			},
			{
				name: "MawSynth - evonyesc",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["detune", "vibrato", "note filter", "chorus", "echo", "reverb"],
					detuneCents: 16,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.0884 }],
					panDelay: 0,
					chorus: 86,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "octave",
					customChipWave: {
						"0": -24,
						"1": -21,
						"2": -17,
						"3": -13,
						"4": -16,
						"5": -17,
						"6": -21,
						"7": -24,
						"8": 24,
						"9": 20,
						"10": 17,
						"11": 13,
						"12": 16,
						"13": 17,
						"14": 20,
						"15": 24,
						"16": -24,
						"17": -22,
						"18": -20,
						"19": -19,
						"20": -20,
						"21": -22,
						"22": -23,
						"23": -24,
						"24": 24,
						"25": 22,
						"26": 20,
						"27": 19,
						"28": 20,
						"29": 22,
						"30": 23,
						"31": 24,
						"32": 24,
						"33": 23,
						"34": 22,
						"35": 20,
						"36": 19,
						"37": 20,
						"38": 22,
						"39": 24,
						"40": -24,
						"41": -23,
						"42": -22,
						"43": -20,
						"44": -19,
						"45": -20,
						"46": -22,
						"47": -24,
						"48": 24,
						"49": 21,
						"50": 17,
						"51": 16,
						"52": 13,
						"53": 17,
						"54": 20,
						"55": 24,
						"56": -24,
						"57": -21,
						"58": -17,
						"59": -16,
						"60": -13,
						"61": -17,
						"62": -21,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "rise",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "low battery - geri",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 19027.31,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 19027.31,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 11.3137 },
					],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←(4 5←6)",
					feedbackType: "5⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "8×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "0.75×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							waveform: 2,
							steps: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 1.2,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
						},
					],
				},
			},
			{
				name: "distorted gumdrop - uncannyblocks fan 33",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
					],
					effects: ["echo", "reverb"],
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1.25,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2←3←4",
					feedbackType: "1→2",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "7×", amplitude: 12, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 3,
							waveform: 0,
							steps: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pyrophone - Exacerbescence",
				generalMidi: false,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 0,
					reverb: 29,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 96,
					spectrum: [
						43, 100, 29, 29, 29, 29, 29, 14, 29, 14, 29, 14, 29, 14, 14, 14, 0, 14, 0,
						14, 0, 14, 0, 14, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Rotre - TanManShum",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "bitcrusher"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.25 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4",
					feedbackType: "4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "sad trombone - NonMouseyCan0n",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["detune", "note filter"],
					detuneCents: 44,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 11.3137,
						},
					],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "XBOX 360 startup - NonMouseyCan0n",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 5,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 }],
					effects: ["transition type", "vibrato", "chorus", "echo", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 0.667,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "fifth",
					customChipWave: {
						"0": 0,
						"1": -2,
						"2": -4,
						"3": -6,
						"4": -9,
						"5": -11,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -11,
						"28": -9,
						"29": -6,
						"30": -4,
						"31": -2,
						"32": 0,
						"33": 3,
						"34": 5,
						"35": 7,
						"36": 10,
						"37": 12,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 12,
						"60": 10,
						"61": 7,
						"62": 5,
						"63": 3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Belgian FM - aciddoesflagbands",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.7071,
						},
					],
					effects: ["chorus", "reverb"],
					panDelay: 0,
					chorus: 100,
					reverb: 19,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Gray's voice - SprinklekitOrion",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
					],
					effects: ["vibrato", "distortion", "bitcrusher", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -1,
					wave: "square",
					unison: "octave",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 15,
						"3": 15,
						"4": 9,
						"5": 9,
						"6": -4,
						"7": -4,
						"8": 0,
						"9": 0,
						"10": -13,
						"11": -13,
						"12": -19,
						"13": -19,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -10,
						"19": -10,
						"20": 0,
						"21": 0,
						"22": -7,
						"23": -7,
						"24": -7,
						"25": -7,
						"26": 0,
						"27": 0,
						"28": 6,
						"29": 6,
						"30": -4,
						"31": -4,
						"32": 3,
						"33": 3,
						"34": -4,
						"35": -4,
						"36": 3,
						"37": 3,
						"38": 3,
						"39": 3,
						"40": 9,
						"41": 9,
						"42": 15,
						"43": 15,
						"44": 15,
						"45": 15,
						"46": 6,
						"47": 6,
						"48": -4,
						"49": -4,
						"50": -4,
						"51": -4,
						"52": -4,
						"53": -4,
						"54": -4,
						"55": -4,
						"56": -4,
						"57": -4,
						"58": 3,
						"59": 3,
						"60": 12,
						"61": 12,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Gabeo pluck - Real_cd",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "note filter"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 50,
					envelopes: [
						{
							target: "supersawDynamism",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Wet spectrum pluck - Real_cd",
				generalMidi: false,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 1000.42, linearGain: 11.3137 }],
					eqFilterType: true,
					eqSimpleCut: 4,
					eqSimplePeak: 7,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus", "reverb"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 100,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Real String - Real_cd",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 1 }],
					effects: ["transition type", "note filter", "chorus"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.3536,
						},
					],
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 71, 57, 43, 43, 43, 43, 29, 29, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Moog Bass - Michael Jackson",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 2,
						},
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 2,
						},
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
					],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 8 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 8 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.0884,
						},
					],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "funky wah bass - 100happee",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.0884,
						},
					],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "funky elec piano 1 - 100happee",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 4,
						},
					],
					effects: ["chord type", "note filter"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←3 2←4",
					feedbackType: "4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "ranger backing synth - 100happee",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "chord type", "vibrato", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 0,
					vibratoSpeed: 2,
					vibratoType: 0,
					panDelay: 10,
					chorus: 57,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -20,
						"2": -16,
						"3": -13,
						"4": -10,
						"5": -8,
						"6": -6,
						"7": -5,
						"8": -4,
						"9": -4,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 4,
						"15": 4,
						"16": 4,
						"17": 4,
						"18": 4,
						"19": 4,
						"20": 8,
						"21": 8,
						"22": 8,
						"23": 8,
						"24": 8,
						"25": 8,
						"26": 8,
						"27": 8,
						"28": 12,
						"29": 12,
						"30": 12,
						"31": 12,
						"32": 12,
						"33": 12,
						"34": 12,
						"35": 12,
						"36": 16,
						"37": 16,
						"38": 16,
						"39": 16,
						"40": 16,
						"41": 16,
						"42": 16,
						"43": 16,
						"44": 20,
						"45": 20,
						"46": 20,
						"47": 20,
						"48": 20,
						"49": 20,
						"50": 20,
						"51": 20,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "bass elec piano - 100happee",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 0.167,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 86, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43, 29, 29, 29, 14, 14, 14,
						0, 0, 0, 0, 29, 14, 29, 14, 14,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "whistle chords - 100happee",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 9513.66,
							linearGain: 0.0884,
						},
					],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 71,
					echoSustain: 71,
					echoDelayBeats: 0.167,
					reverb: 48,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "1 2←3←4",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Windpipe - UBF33",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 13,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←4)",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Jester Bass - Abyssal Jester",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 11.3137,
						},
					],
					effects: ["pitch shift", "distortion", "bitcrusher", "chorus"],
					pitchShiftSemitones: 0,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 3,
							waveform: 5,
							steps: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
							index: 2,
							waveform: 1,
							steps: 2,
						},
					],
				},
			},
			{
				name: "FM Clarinet - Q",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "vibrato"],
					detuneCents: 25,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 45,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "absine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "fastsine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			{
				name: "rave synth - Mathieu",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					eqSubFilters1: [],
					effects: ["pitch shift", "chorus"],
					pitchShiftSemitones: 0,
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cello 2 - Mathieu",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "chorus"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "(1 2)←3←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "16×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Hardbass synth - Mathieu",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
					],
					eqSubFilters1: [
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.3536 },
					],
					effects: ["distortion", "chorus"],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					chorus: 86,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "dog noises - UBF33",
				generalMidi: false,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.25,
						},
					],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						57, 0, 14, 29, 0, 29, 14, 100, 43, 0, 0, 57, 14, 14, 86, 43, 100, 14, 86,
						14, 43, 100, 0, 43, 0, 29, 43, 0, 29, 0,
					],
					unison: "spinner",
					envelopes: [],
				},
			},
			{
				name: "Accordian-Piano crossover",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 2.8284,
						},
					],
					effects: ["transition type", "vibrato", "note filter", "bitcrusher"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 13,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 14,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						86, 86, 71, 71, 57, 57, 43, 29, 14, 29, 29, 29, 29, 29, 29, 29, 29, 43, 43,
						43, 43, 43, 29, 14, 14, 0, 0, 0,
					],
					unison: "energetic",
					stringSustain: 79,
					envelopes: [],
				},
			},
			{
				name: "DX7 BRASS 1 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "vibrato"],
					detuneCents: -3,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 9,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "6⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6], [6], [6], [5], [], []], carrierCount: 4 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "DX7 BRASS 3 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 }],
					effects: ["pitch shift", "vibrato", "note filter"],
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 8,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 }],
					panDelay: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [5], [6], []], carrierCount: 1 },
					customFeedback: { mods: [[], [], [3], [], [], []] },
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 13,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "DX7 STRINGS 2 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 28,
					eqSubFilters0: [],
					effects: ["vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 49,
					vibratoSpeed: 7,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "3⟲",
					feedbackAmplitude: 5,
					customAlgorithm: { mods: [[3], [4], [], [5], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 95,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 13,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 95,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "DX7 E PIANO 1 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune"],
					detuneCents: 4,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "Custom",
					feedbackType: "6⟲",
					feedbackAmplitude: 3,
					customAlgorithm: { mods: [[6], [4], [5], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							pitchEnvelopeStart: 60,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 1.2,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "DX7 BASS 1 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 3, 5], [], [4], [], [6], []], carrierCount: 1 },
					customFeedback: { mods: [[], [], [], [], [], [5]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "18×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
							index: 4,
							pitchEnvelopeStart: 41,
							pitchEnvelopeEnd: 46,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							pitchEnvelopeStart: 24,
							pitchEnvelopeEnd: 72,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							pitchEnvelopeStart: 36,
							pitchEnvelopeEnd: 84,
						},
					],
				},
			},
			{
				name: "DX7 E ORGAN 1 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "DX7 HARPSICHORD 1 - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "6⟲",
					feedbackAmplitude: 2,
					customAlgorithm: { mods: [[4], [5], [6], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 5,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							pitchEnvelopeStart: 55,
							pitchEnvelopeEnd: 84,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
							index: 5,
							pitchEnvelopeStart: 55,
							pitchEnvelopeEnd: 84,
						},
					],
				},
			},
			{
				name: "DX7 TUBULAR BELLS - hoongtube",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["detune", "reverb"],
					detuneCents: -4,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "Custom",
					feedbackType: "4⟲",
					feedbackAmplitude: 12,
					customAlgorithm: { mods: [[6], [5], [4], [], [], []], carrierCount: 3 },
					operators: [
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "pitch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
							index: 2,
							pitchEnvelopeStart: 36,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
							pitchEnvelopeStart: 48,
							pitchEnvelopeEnd: 91,
						},
					],
				},
			},
			{
				name: "Warped Melancholy Chirp - Lumic0re",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["granular", "bitcrusher", "reverb"],
					granular: 4,
					grainSize: 19,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "sandbox nes pulse",
					unison: "fluctuate",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 1,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 2,
					envelopes: [
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "The Best Hi Hat Ever - XyNo",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.0884 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -24,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "Flight Bass - UBF33",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					effects: ["vibrato", "note filter"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 45,
					decimalOffset: 0,
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.01,
					unisonOffset: 0.5,
					unisonExpression: 0.75,
					unisonSign: 1.2,
					envelopes: [],
				},
			},
			{
				name: "Dreamy Pad - UBF33",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
					],
					effects: ["vibrato", "note filter", "echo", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1.167,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 47,
					decimalOffset: 0,
					dynamism: 83,
					spread: 58,
					shape: 100,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Synth Why - UBF33",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 0.1768,
						},
					],
					effects: ["vibrato", "note filter"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 5.6569 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 42,
					decimalOffset: 0,
					unison: "octave",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Glitched Ice - Respect_me742",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 11.3137,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 11.3137,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 },
					],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -6,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [],
				},
			},
			{
				name: "Hallow Harpischord - redactedthe2nd",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.7071 },
					],
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "shimmer",
					customChipWave: {
						"0": 8,
						"1": 4,
						"2": 0,
						"3": -3,
						"4": -6,
						"5": -8,
						"6": -10,
						"7": -10,
						"8": -9,
						"9": -8,
						"10": -6,
						"11": -3,
						"12": 1,
						"13": 6,
						"14": 11,
						"15": 17,
						"16": 22,
						"17": -20,
						"18": -15,
						"19": -10,
						"20": -6,
						"21": -3,
						"22": 0,
						"23": 2,
						"24": 3,
						"25": 3,
						"26": 2,
						"27": 0,
						"28": -3,
						"29": -6,
						"30": -10,
						"31": -14,
						"32": -18,
						"33": -22,
						"34": 23,
						"35": 20,
						"36": 17,
						"37": 15,
						"38": 14,
						"39": 14,
						"40": 15,
						"41": 17,
						"42": 20,
						"43": 24,
						"44": -20,
						"45": -15,
						"46": -10,
						"47": -4,
						"48": 1,
						"49": 7,
						"50": 12,
						"51": 16,
						"52": 20,
						"53": 23,
						"54": -23,
						"55": -21,
						"56": -21,
						"57": -21,
						"58": -23,
						"59": 23,
						"60": 20,
						"61": 16,
						"62": 13,
						"63": 9,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Broken Chip - redactedthe2nd",
				generalMidi: false,
				tags: ["chip", "customchip"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter", "reverb"],
					pitchShiftSemitones: 13,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "inject",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "pitchShift",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Unearthly Vocal - redactedthe2nd",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 8 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 176.78, linearGain: 8 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 8 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 176.78, linearGain: 8 },
					],
					eqSubFilters1: [],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0.135,
					fadeOutTicks: 48,
					pulseWidth: 45,
					decimalOffset: 0,
					unison: "chorus",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.09,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Orchestra Guitar - redactedthe2nd",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 353.55,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 0.917,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					algorithm: "(1 2)←3←4",
					feedbackType: "1↔4 2↔3",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "absine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "0.75×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.07,
							perEnvelopeLowerBound: 1.1,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Overdrive Waves - redactedthe2nd",
				generalMidi: false,
				tags: ["fm", "fm6op"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["vibrato", "bitcrusher", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "1←(2 3←5 4←6)",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 3, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "pulse width", pulseWidth: 2 },
					],
					envelopes: [
						{
							target: "bitcrusherFrequency",
							envelope: "rise",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.08,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							waveform: 3,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Solo Alien - redactedthe2nd",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [],
					effects: ["vibrato"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						71, 29, 14, 86, 71, 100, 57, 0, 71, 29, 14, 57, 14, 100, 71, 0, 43, 57, 29,
						57, 86, 29, 29, 29, 43, 14, 14, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Critter Horn - redactedthe2nd",
				generalMidi: false,
				tags: ["pwm"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1 }],
					eqSubFilters1: [],
					effects: ["vibrato", "note filter"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 }],
					panDelay: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "bowed",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 8.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "light chip bass - Lumic0re",
				generalMidi: false,
				tags: ["chip", "chipwave", "featured"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.0884,
						},
					],
					effects: ["vibrato", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 16,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					wave: "todbox beta banana wave",
					unison: "bass",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 4,
					chipWaveLoopEnd: 34,
					chipWaveLoopMode: 1,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Odd Fanfare - Lumic0re",
				generalMidi: false,
				tags: ["pwm", "featured"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 8 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 1 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 8 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.25 },
					],
					effects: ["detune", "note filter", "bitcrusher", "chorus", "ring mod"],
					detuneCents: -100,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2.8284,
						},
					],
					ringMod: 14,
					ringModHz: 78,
					ringModWaveformIndex: 6,
					ringModPulseWidth: 14,
					ringModHzOffset: 50,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 57,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 24,
					pulseWidth: 21,
					decimalOffset: 70,
					unison: "chorus",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pretty cool bass - Lumic0re",
				generalMidi: false,
				tags: ["chip", "chipwave", "featured"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2.8284,
						},
					],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					distortion: 29,
					aliases: false,
					chorus: 29,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "modbox atari bass",
					unison: "hyper",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cute music box  - jacobis12344",
				generalMidi: false,
				tags: ["pickedstring", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2,
						},
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2,
						},
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 1.4142 },
					],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 2 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					panDelay: 0,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						57, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0,
					],
					unison: "octave",
					stringSustain: 64,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Weird Tubathing - jacobis12344",
				generalMidi: false,
				tags: ["fm", "fm4op", "brass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.3536 }],
					effects: ["vibrato", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←3 2←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Nostalgic Childhood Organ - PiglinMiguel",
				generalMidi: false,
				tags: ["spectrum"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 2,
						},
					],
					effects: ["chord type", "vibrato", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					spectrum: [
						100, 43, 43, 0, 14, 43, 29, 57, 0, 29, 0, 71, 0, 29, 71, 0, 100, 43, 100, 0,
						29, 86, 14, 43, 0, 29, 14, 0, 29, 14,
					],
					unison: "piano",
					envelopes: [],
				},
			},
			{
				name: "Drone-like Saw - PiglinMiguel",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.125 }],
					panDelay: 0,
					reverb: 55,
					fadeInSeconds: 0.075,
					fadeOutTicks: 48,
					wave: "sandbox narrow saw",
					unison: "recurve",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 33,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "“I feel pain” Distortion Saw - PiglinMiguel",
				generalMidi: false,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 0.125,
						},
					],
					effects: ["bitcrusher", "reverb"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1 2←(3 4)",
					feedbackType: "(1 2 3)→4",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "0.5×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "bitcrusherQuantization",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Brown Bass - PiglinMiguel",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 4000, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 4000, linearGain: 0.25 },
					],
					effects: ["chord type", "vibrato", "note filter", "distortion", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1.4142,
						},
					],
					distortion: 86,
					aliases: false,
					panDelay: 0,
					reverb: 16,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 6,
					pulseWidth: 48,
					decimalOffset: 0,
					dynamism: 50,
					spread: 42,
					shape: 17,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 1.2,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Soul choir - Luxian",
				generalMidi: false,
				tags: ["spectrum", "vocal"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 }],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					unison: "none",
					spectrum: [
						100, 0, 0, 29, 0, 14, 14, 71, 29, 0, 0, 100, 29, 0, 71, 0, 86, 14, 71, 29,
						43, 86, 0, 14, 14, 0, 0, 14, 0, 0,
					],
					envelopes: [],
				},
			},
			{
				name: "Zilly supsbass - Luxian",
				generalMidi: false,
				tags: ["supersaw"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 4 },
					],
					effects: ["vibrato"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.0938,
					fadeOutTicks: -3,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 33,
					spread: 17,
					shape: 17,
					envelopes: [],
				},
			},
			{
				name: "Zilly lead - Luxian",
				generalMidi: false,
				tags: ["fm", "fm4op", "pad"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 2378.41, linearGain: 8 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2378.41, linearGain: 8 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "feedbackAmplitude", envelope: "swell 2" }],
				},
			},
			{
				name: "Bit Cruskles - Luxian",
				generalMidi: false,
				tags: ["harmonics", "keys"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "peak", cutoffHz: 2378.41, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2378.41, linearGain: 0.3536 }],
					effects: ["vibrato", "bitcrusher"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 86,
					panDelay: 0,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 6,
					harmonics: [
						86, 71, 29, 100, 57, 71, 43, 14, 29, 29, 14, 43, 0, 14, 29, 14, 14, 29, 14,
						14, 14, 14, 14, 29, 0, 14, 0, 14,
					],
					unison: "shimmer",
					envelopes: [],
				},
			},
			{
				name: "Whimper pad - Luxian",
				generalMidi: false,
				tags: ["harmonics", "pad"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 16000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 16000, linearGain: 0.3536 },
					],
					effects: ["transition type", "chord type", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					harmonics: [
						71, 57, 71, 86, 100, 71, 57, 57, 57, 57, 57, 57, 57, 43, 29, 43, 43, 43, 43,
						43, 43, 43, 29, 29, 29, 29, 29, 29,
					],
					unison: "spinner",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 2" }],
				},
			},
			{
				name: "Clavinet chip - Luxian",
				generalMidi: false,
				tags: ["chip", "customchip", "keys"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					unison: "shimmer",
					wave: "square",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 0,
						"31": 0,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 0,
						"61": 0,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "louis cole synth clavinet - 100happee",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "low-pass",
							cutoffHz: 19027.31,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
					],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Broken Dial - samology",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.5 },
					],
					effects: ["note filter", "distortion", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.5,
						},
					],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 86, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 14, 0, 86, 43, 0, 100, 0, 43, 29, 0,
						0, 29, 86, 0, 29, 0,
					],
					unison: "piano",
					stringSustain: 43,
					envelopes: [],
				},
			},
			{
				name: "AOUW Lead- AcidDoesFlagBands",
				generalMidi: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "distortion", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 43,
					aliases: false,
					panDelay: 10,
					echoSustain: 100,
					echoDelayBeats: 0.167,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "hold",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Voiced Harpsichord - AcidDoesFlagBands",
				generalMidi: false,
				tags: ["pickedstring"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
					],
					effects: ["transition type", "note filter", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
					],
					panDelay: 0,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "voiced",
					stringSustain: 86,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "note size", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "twang 1",
							index: 1,
						},
						{ target: "noteFilterFreq", envelope: "twang 1", index: 1 },
					],
				},
			},
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
		]),
	},
	{
		name: "DX7FM's Novelty Presets",
		presets: toNameMap([
			{
				name: "Sinehell",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							steps: 24,
							seed: 1,
							waveform: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							steps: 24,
							seed: 2,
							waveform: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							steps: 24,
							seed: 3,
							waveform: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							steps: 24,
							seed: 4,
							waveform: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
							steps: 24,
							seed: 5,
							waveform: 3,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							steps: 24,
							seed: 6,
							waveform: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							steps: 2,
							seed: 7,
							waveform: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							steps: 2,
							seed: 8,
							waveform: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							steps: 2,
							seed: 9,
							waveform: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
							steps: 2,
							seed: 10,
							waveform: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
							steps: 2,
							seed: 11,
							waveform: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							steps: 2,
							seed: 12,
							waveform: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 2,
							seed: 13,
							waveform: 3,
						},
					],
				},
			},
			{
				name: "Laserdeath",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 707.11, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 0.083,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Nuke Alarm",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "5⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[6, 5], [], [], [], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Alien Ray",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 14,
					echoSustain: 14,
					echoDelayBeats: 0.417,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Magnet Bounce",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "decay",
							inverse: true,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Alien Ray 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "0.12×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Sillymetal",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 15,
					customAlgorithm: { mods: [[2, 3], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Protogen Voice",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo"],
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[2, 3, 4], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.0 presets--------------
			{
				name: "Shitsaw",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion", "bitcrusher"],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "Custom",
					feedbackAmplitude: 15,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 2 },
					customFeedback: { mods: [[2, 1], [1, 2], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Dyu Dyu",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "chorus"],
					pitchShiftSemitones: 0,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 2,
					customAlgorithm: { mods: [[2], [], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "250×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Gaisi Spectrum",
				generalMidi: false,
				tags: ["spectrum", "dx7fm", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "distortion"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					distortion: 100,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 57, 57, 57, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Hell Portal",
				generalMidi: false,
				tags: ["harmonics", "dx7fm", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 8 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 8 },
					],
					effects: ["note filter", "bitcrusher", "reverb", "ring mod"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 8 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					ringMod: 57,
					ringModHz: 78,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						43, 0, 29, 71, 43, 14, 71, 71, 57, 29, 14, 29, 29, 100, 57, 71, 43, 43, 43,
						14, 100, 71, 57, 57, 14, 86, 14, 100,
					],
					unison: "FART",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "linear",
							inverse: true,
							perEnvelopeSpeed: 0.9,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
						},
						{
							target: "ringModulation",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "ringModulationHz",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cold Gate",
				generalMidi: false,
				tags: ["spectrum", "dx7fm", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1.4142 },
					],
					effects: ["vibrato", "ring mod"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					ringMod: 71,
					ringModHz: 67,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 14, 0, 0, 0, 0, 14, 86, 14, 0, 43, 86, 29, 0, 57, 14, 57, 14, 86, 0, 0,
						86, 0, 14, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					envelopes: [],
				},
			},
			{
				name: "Ear Kill",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["granular", "distortion"],
					granular: 1,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 57,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "4⟲",
					feedbackAmplitude: 8,
					customAlgorithm: { mods: [[2, 3, 4], [5], [], [6], [6], []], carrierCount: 1 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Shit 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 9,
					monoChordTone: 1,
					pitchShiftSemitones: 24,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
					],
					granular: 2,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 0,
					bitcrusherQuantization: 100,
					panDelay: 0,
					chorus: 100,
					echoSustain: 100,
					echoDelayBeats: 2,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2(3(4(5(6",
					feedbackType: "(1,2,3,4,5)→6",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.12×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 9, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.25×",
							amplitude: 12,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "0.75×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Cold Gate 2",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.3536 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 86,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 3 4 5 6)",
					feedbackType: "(1,2,3,4,5)→6",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "0.25×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 10, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "~1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 11,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ear Crash",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "distortion"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "(1 2 3 4 5)←6",
					feedbackType: "3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Wia Iya",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "peak", cutoffHz: 500, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 500, linearGain: 0.5 }],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 }],
					panDelay: 0,
					chorus: 100,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←(2(3(4(5(6",
					feedbackType: "2→3",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "0.5×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 1, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 1, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "19×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.6667,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Metal Bird",
				generalMidi: false,
				tags: ["pickedstring", "dx7fm", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 1,
						},
					],
					effects: ["note filter", "bitcrusher", "ring mod"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 5.6569 }],
					ringMod: 100,
					ringModHz: 95,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 100, 100, 100, 14, 29, 0, 100, 0, 0, 43, 0, 100, 0, 0, 100, 0, 0, 0,
						57, 0, 0, 0, 0, 0, 86, 0, 0,
					],
					unison: "none",
					stringSustain: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
						{
							target: "ringModulationHz",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Bad UFO",
				generalMidi: false,
				tags: ["chip", "chipwave", "dx7fm", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: ["echo", "reverb", "ring mod"],
					ringMod: 71,
					ringModHz: 41,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 0.917,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sine",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Computer",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 }],
					effects: ["note filter", "chorus", "echo", "ring mod"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					ringMod: 86,
					ringModHz: 83,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 10,
					chorus: 14,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 9,
							seed: 26,
							waveform: 0,
						},
						{
							target: "operatorFrequency",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							steps: 13,
							seed: 30,
							waveform: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 17,
							seed: 34,
							waveform: 0,
						},
					],
				},
			},
			{
				name: "Record Scratch",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 1681.79,
							linearGain: 1.4142,
						},
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
						{
							type: "high-pass",
							cutoffHz: 1681.79,
							linearGain: 1.4142,
						},
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
					],
					panDelay: 0,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2(3(4(5(6",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "white noise", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "chorus",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Batsy Pulse",
				generalMidi: false,
				tags: ["fm", "fm6op", "dx7fm", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "vibrato", "note filter", "echo"],
					pitchShiftSemitones: 14,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2 }],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 0.917,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -6,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~2×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 1, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "dx7fm", "novelty"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "dx7fm", "novelty"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "dx7fm", "novelty"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "dx7fm", "novelty"], settings: {} },
		]),
	},
];
